// @ts-nocheck
import { GreifOrderUploadModel } from "@insite/client-framework/Types/ApiModels";
import { GetGreifOrderUploadApiParameter, submitOrderUpload } from "@store/Framework/Services/GreifOrderUploadService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = Pick<GreifOrderUploadModel, "documents" | "webOrderNumber"> & HasOnError & HasOnSuccess;
type HandlerType = ApiHandlerDiscreteParameter<Parameter, GetGreifOrderUploadApiParameter, GreifOrderUploadModel>;

export const DispatchBeginSubmitUploadedOrder: HandlerType = props => {
    props.dispatch({
        type: "Greif/ComponentsReducer/GreifOrderUpload/BeginSubmitUploadedOrder",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const { ...apiParameter } = props.parameter;
    props.apiParameter = {
        greifOrderUploadParameter: apiParameter,
    } as any;
};

export const SubmitUploadedOrder: HandlerType = props => {
    submitOrderUpload(props.apiParameter);
};

export const DispatchCompleteSubmitUploadedOrder: HandlerType = props => {
    props.dispatch({
        type: "Greif/ComponentsReducer/GreifOrderUpload/CompleteSubmitUploadedOrder",
    });
};

export const chain = [
    DispatchBeginSubmitUploadedOrder,
    PopulateApiParameter,
    SubmitUploadedOrder,
    DispatchCompleteSubmitUploadedOrder,
];

const submitUploadedOrder = createHandlerChainRunner(chain, "SubmitUploadedOrder");
export default submitUploadedOrder;
